import React, { useState } from "react";
import { MDBDataTable } from "mdbreact";
import EntriesSelector from "../tableServerPagination/entriesSelector";
import PaginationButtons from "../tableServerPagination/paginationButtons";
//SweetAlert
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
//i18n
import { withNamespaces } from "react-i18next";

const TasksList = function (props) {

  const [size, setSize] = useState(100);
  const [page, setPage] = useState(1);

  return (
    <React.Fragment>

      <EntriesSelector
        label={props.t("Show tasks")}
        size={size} setSize={setSize}
        setPage={setPage}
        getEntries={props.getTask}
        extraArgs={props.extraArgs}
      />
      <MDBDataTable
        responsive striped bordered data={props.taskslist}
        info={false}
        paginationLabel={[props.t("Previous"), props.t("Next")]}
        entriesLabel={props.t("Show tasks")}
        entries={10}
        noRecordsFoundLabel={props.t("No matching records found")}
        infoLabel={[
          props.t("Showing"),
          props.t("to"),
          props.t("of"),
          props.t("entries"),
        ]}
        searchLabel={props.t("Search")}
        onPageChange={event => this.pageChange(event)}
        paging={false}
      />
      <PaginationButtons
        size={size}
        page={page} setPage={setPage}
        totalPages={props.totalPages}
        getEntries={props.getTask}
        extraArgs={props.extraArgs}
        nextBtnLabel={props.t("Next")}
        prevBtnLabel={props.t("Previous")}
        t={props.t}
      />
    </React.Fragment>
  );
}

export default (withNamespaces()(TasksList))
